<template>
  <div v-if="!isPending && totalCount > 1" class="c-pagination">
    <router-link
      class="c-pagination__button"
      :class="page === 1 ? 'c-pagination__button--disabled bg-transparent' : ''"
      :to="buildQuery({ page: page - 1 })"
      :disabled="page === 1"
      :event="page === 1 ? '' : 'click'"
    >
      <i class="far fa-arrow-left" />
    </router-link>
    <div class="c-pagination__body">
      <span>
        {{ getProductOverviewTranslations['ProductsOverview.Pagination.Page'] }}
      </span>
      <select
        id="pagination-dropdown"
        v-model="page"
        name="pagination-dropdown"
        class="c-pagination__pages bg-transparent"
      >
        <option
          v-for="paginationItem in totalPages"
          :key="paginationItem"
          :value="paginationItem"
        >
          {{ paginationItem }}
        </option>
      </select>
      <span>
        {{ getProductOverviewTranslations['ProductsOverview.Pagination.Of'] }}
        {{ totalPages }}
      </span>
    </div>
    <router-link
      class="c-pagination__button"
      :class="
        page === lastPage ? 'c-pagination__button--disabled bg-transparent' : ''
      "
      :to="buildQuery({ page: page + 1 })"
      :disabled="page === lastPage"
      :event="page === lastPage ? '' : 'click'"
    >
      <i class="far fa-arrow-right" />
    </router-link>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  data() {
    return {
      currentPage: 1
    };
  },
  computed: {
    ...mapGetters('productSearch', ['buildQuery']),
    ...mapGetters('translations', ['getProductOverviewTranslations']),
    ...mapState('productSearch', ['isPending', 'query', 'totalCount']),
    lastPage() {
      return Math.ceil(this.totalCount / this.top);
    },
    page: {
      get() {
        return this.query.page;
      },
      set(value) {
        this.$router.push(
          this.buildQuery({ page: value }, undefined, { scroll: false })
        );
      }
    },
    top() {
      return this.query.top;
    },
    totalPages() {
      return Math.ceil(this.totalCount / this.top);
    }
  },
  watch: {
    page() {
      document.getElementById('products-overview').scrollIntoView();
    }
  },
  mounted() {
    this.currentPage = this.query.page || 1;
  }
};
</script>

<style lang="scss" scoped>
.c-pagination {
  display: flex;
  justify-content: center;
}
</style>
